import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/content/site";
import { useRadar } from "@/components/home/RadarPreview";
import LatestResearchBar from "@/components/site/LatestResearchBar";

const slug = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const SiteNav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const { pathname } = useLocation();
    const { data: radar } = useRadar(3);
    // Radar só aparece no menu quando houver leituras publicadas.
    const items = NAV.filter((n) => !n.radar || (radar && radar.length > 0));

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => setOpen(false), [pathname]);

    const solid = scrolled || open;
    const linkCls = ({ isActive }) =>
        `font-sans text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${isActive ? "text-[#C7A659]" : "text-[#D7D1BF] hover:text-[#F2EFE5]"}`;

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 border-b ${solid ? "bg-[#0A1812]/95 backdrop-blur-md border-[#1B3025]" : "bg-transparent border-transparent"}`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-[72px] flex items-center justify-between gap-6">
                <Link to="/" data-testid="nav-brand" className="font-serif text-[16px] md:text-[17px] font-light text-[#D7D1BF] hover:text-[#F2EFE5] tracking-[0.02em] transition-colors">
                    Raquel Lauria
                </Link>
                <nav className="hidden lg:flex items-center gap-8" aria-label="Navegação principal">
                    {items.map((n) => (
                        <NavLink key={n.to} to={n.to} end data-testid={`nav-link-${slug(n.label)}`} className={linkCls}>
                            {n.label}
                        </NavLink>
                    ))}
                </nav>
                <button
                    type="button"
                    data-testid="nav-mobile-toggle"
                    onClick={() => setOpen((v) => !v)}
                    aria-label={open ? "Fechar menu" : "Abrir menu"}
                    className="lg:hidden text-[#F2EFE5] p-2 -mr-2"
                >
                    {open ? <X size={22} strokeWidth={1.3} /> : <Menu size={22} strokeWidth={1.3} />}
                </button>
            </div>
            {pathname === "/" && !open && <LatestResearchBar />}
            {open && (
                <nav data-testid="nav-mobile-menu" className="lg:hidden border-t border-[#1B3025] bg-[#0A1812] px-6 py-6 flex flex-col gap-5" aria-label="Navegação móvel">
                    {items.map((n) => (
                        <Link key={n.to} to={n.to} data-testid={`nav-mobile-link-${slug(n.label)}`} className="font-serif text-[22px] font-light text-[#F2EFE5]">
                            {n.label}
                        </Link>
                    ))}
                </nav>
            )}
        </header>
    );
};

export default SiteNav;
